import { getInitialViewState } from 'components/map/location/defaultMapLocation';
import { useIsWide } from 'libs/utils/logic/ui/responsiveLogic';
import { CustomMapPage } from 'pages/custom/shared/CustomMapPage';
import { CompanyButtons } from 'pages/custom/shared/detail/CompanyButtons';
import { S_PageStyle } from 'pages/page/PageStyle';
import { useContext } from 'react';
import { CtxView } from 'session/ctxView';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const UIAPage = (props: Props): JSX.Element => {
    const isWide = useIsWide();
    const ctxView = useContext(CtxView);

    function zoom() {
        const initialMapPosition = getInitialViewState(ctxView.map, isWide);
        if (initialMapPosition.bounds) {
            ctxView.mapRef.current.fitBounds(initialMapPosition.bounds);
        } else {
            ctxView.mapRef.current.flyTo({
                zoom: initialMapPosition.zoom,
                center: [initialMapPosition.longitude, initialMapPosition.latitude]
            });
        }
    }

    return (
        <S_UIAPage className={props.className}>
            <CustomMapPage
                interactiveMessage={true}
                mapId={'25cbcd6a-91e6-4dc4-8892-511fa04e9663'}
                header={{
                    logo: 'https://dvtqxks0zalev.cloudfront.net/f3ef42a6-0cb6-49f2-94f6-9d2d2751f169.png',
                    logoText: 'Karrieredagen',
                    logoSubtext: 'Interaktivt kart',
                    link: 'https://www.karrieredagenuia.com/',
                    linkText: Localization.WEBSITE
                }}
                controls={<CompanyButtons />}
                onMarkerSelected={(markerId) => {
                    if (markerId === '0.6919517815065341') {
                        zoom();
                        return true;
                    }
                }}
            />
        </S_UIAPage>
    );
};

const S_UIAPage = styled(S_PageStyle)`
    display: flex;
    flex-direction: column;
`;
